// extracted by mini-css-extract-plugin
module.exports = {"card-container":"_7mDcF","column":"_1CxDk","first-col":"_1-IIo"};